import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Sofía', 'Martín', 'Daniela', 'Julián', 'Camila', 'Mateo', 'Valentina', 'Lucas', 'Florencia', 'Agustín', 'Micaela', 'Tomás'];
const CITIES = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Santa Fe'];
const PLANS = ['Transformación Completa', 'Plan Esencial'];
interface PopupData {
  name: string;
  city: string;
  plan: string;
  time: number;
}
export function PurchasePopup() {
  const [popup, setPopup] = useState<PopupData | null>(null);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      const plan = PLANS[Math.floor(Math.random() * PLANS.length)];
      const time = Math.floor(Math.random() * 10) + 1;
      setPopup({
        name,
        city,
        plan,
        time
      });
      // Hide after 5 seconds
      setTimeout(() => setPopup(null), 5000);
      // Schedule next popup (between 40s and 60s)
      const nextDelay = Math.floor(Math.random() * (60000 - 40000 + 1) + 40000);
      timeoutId = setTimeout(showPopup, nextDelay);
    };
    // Initial delay before first popup (5s to 15s)
    const initialDelay = Math.floor(Math.random() * 10000) + 5000;
    timeoutId = setTimeout(showPopup, initialDelay);
    return () => clearTimeout(timeoutId);
  }, []);
  return <AnimatePresence data-id="element-206">
      {popup && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white p-4 rounded-xl shadow-xl border border-gold/20 max-w-xs flex items-start gap-3" data-id="element-207">
          <CheckCircle2 className="text-green-500 w-6 h-6 shrink-0 mt-0.5" data-id="element-208" />
          <div data-id="element-209">
            <p className="text-sm font-sans text-brown leading-tight" data-id="element-210">
              <strong data-id="element-211">{popup.name}</strong> de {popup.city} compró
            </p>
            <p className="text-sm font-sans font-bold text-gold mt-0.5 leading-tight" data-id="element-212">
              {popup.plan}
            </p>
            <p className="text-xs font-sans text-brown/50 mt-1.5" data-id="element-213">
              hace {popup.time} {popup.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}